import React from "react";

export default function ImageBox(props) {
  return (
    <div className="overflow-hidden rounded-md bg-slate-50 p-3 ring-1 ring-slate-100">
      <img
        className="mx-auto max-h-[520px] w-full rounded-md object-contain"
        src={props.link}
        alt="Describe image prompt"
      />
    </div>
  );
}
